export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  return bytes.map((byte, i) => binaryString.charCodeAt(i));
}

export function getBlobFileURL(body) {
  const blob = new Blob([body]);
  return URL.createObjectURL(blob);
}

export function downloadBlobFile(url, filename, extension = "pdf") {
  const fileName = `${filename}.${extension}`;
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
